module.exports = __webpack_public_path__ + "static/postcard_back-a3da5a86288b8dfc35ea9bb789f7fc6f.jpg";